module.exports = __webpack_public_path__ + "img/field.e79930b1.png";